import { z } from "zod";

/**
 * Browser-side env. Hard rule #7 — the ONLY place `import.meta.env` is read.
 *
 * Vite picks up `VITE_*` prefixed vars at build time. Everything else is
 * passed in as a parameter at the call-site.
 */
const envSchema = z.object({
  /**
   * The platform API (`apps/api`) — the only backend this flow talks to. It
   * serves the census eligibility check and proxies the census draft (seed /
   * prefill / save / submit) to the internal db-service, the single source of
   * truth (`/api/quote-census/*`).
   */
  VITE_API_BASE_URL: z.string().default(""),
  VITE_COGNITO_USER_POOL_ID: z.string().default(""),
  VITE_COGNITO_CLIENT_ID: z.string().default(""),
  VITE_COGNITO_REGION: z.string().default("us-east-1"),
  /**
   * Vite-provided build mode. `MODE=test` disables PostHog; `development`
   * usually omits `VITE_POSTHOG_KEY`, which also disables it.
   */
  MODE: z.enum(["development", "production", "test"]).default("production"),
  VITE_POSTHOG_KEY: z.string().default(""),
  VITE_POSTHOG_HOST: z.string().default("https://us.i.posthog.com"),
  VITE_GTM_ID: z.string().default(""),
});

export type CompanyCensusEnv = z.infer<typeof envSchema>;

let cached: CompanyCensusEnv | null = null;

export function loadCompanyCensusEnv(): CompanyCensusEnv {
  if (cached) return cached;
  cached = envSchema.parse(import.meta.env);
  return cached;
}
